<h1 id="#" tabindex="0">The Perfect Fit Quiz</h1>
<div class="row">
    <div class="col-lg-6">
        <section class="quiz" id="quiz-questions">
            <h2 tabindex="0">Consider the Following Questions</h2>    
            <ol tabindex="0">
                <li>Is the weight of your shoe crucial to your training?</li>
                <li>Do you have multiple speed workouts over the course of a week?</li>
                <li>Are you running 25+ miles per week?</li> 
                <li>Do you land hard or heavy when you walk or run?</li>
                <li>Are you sensitive to ground impact?</li>
                <li>Do your ankles turn in when you walk or run?</li> 
                <li>Do you have low or collapsing arches when you walk?</li> 
                <li>Do the inside of your ankles or shins hurt when you walk or run for long periods of time?</li>
            </ol>
        </section>
    </div>
    <div class="col-lg-6">
        <section class="quiz" id="quiz-answers">
            <h2 tabindex="0">Let's Find Some Shoes!</h2>
            <p tabindex="0">If you answered yes to question 1 or 2, then you should consider a lighter weight shoe with more <a routerLink="/quiz" fragment="speed" aria-label="click to go to the speed section of the quiz page">speed</a>.</p>
            <p tabindex="0">If you answered yes to question 3, 4, or 5, then you should consider a shoe with more <a routerLink="/quiz" fragment="cushion" aria-label="click to go to the cushion section of the quiz page">cushion</a>.</p> 
            <p tabindex="0">If you answered yes to question 6, 7, or 8, then you should consider a shoe with more <a routerLink="/quiz" fragment="stability" aria-label="click to go to the stability section of the quiz page">stability</a>.</p>
        </section>
    </div>
</div>
<app-speed-shoes [speedShoes]="speedShoes"></app-speed-shoes>
<app-cushion-shoes [cushionShoes]="cushionShoes"></app-cushion-shoes>
<app-stability-shoes [stabilityShoes]="stabilityShoes"></app-stability-shoes>
<section id="MoreShoes">
    <div class="row">
        <div class="col-md-12">
            <h2 tabindex="0">Want More Options?</h2>
            <p tabindex="0">These are some of our favorites, but in case you want to do your own digging, use our app to search the sneaker database and discover shoes based on your customized search parameters!</p>
            <p tabindex="0">If you find a shoe you like, you can add it to your favorites and pin it. This way you can come back to it later while making new searches!</p>
        </div>
    </div>
    <a routerLink="/search" tabindex="0" aria-label="Click to Search for Shoes!" id="search-shoes"><button id="search-shoes-btn" width = 100% height = 100% tabindex="-1">Search for Shoes!</button></a>
</section>